import React, { useRef, useState } from 'react';
import css from './ListUser.module.scss';
import { NavLink } from "react-router-dom";
import ATable from '../../../Components/ATable/ATable';
import SettingTable from '../../../Components/ATable/SettingTable';
import { getDataListUser } from '../../../Services/Admin/ListAdminServices';

const ListUserPage = () => {
    const aTable = useRef();


    let columns = [
        {title: "No", field: "no", align: "center", sortable: true},
        {title: "Username", field: "username", align: "left", sortable: true},
        {title: "Email", field: "email", align: "left", sortable: true},
        {title: "Phone Number", field: "phone", align: "left", sortable: true },
        {
            title: "Action", 
            field: "action", 
            align: "center", 
            sortable: true, 
            type:'action', 
            link: '/admin/list-user/edit-user',
            value: <i class="fi fi-rr-edit"></i>,
            primary :'_id',
            admin: true,   
        }
    ];
    

    const settingTable = {
        admin:false,
        FilterSearchAll : true,
        CreateButtonWithLink : '/admin/list-user/add-user',
        filter:true,    
    };

    

    return (
        <div className='wrap_admin'>
            <div className='row vh-100'>
                <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>

                    <div className={`${css.content_position} row`} style={{ marginBottom: 100 }}>
                        <SettingTable columns={columns} data={getDataListUser} {...settingTable} />

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListUserPage;
